import React, { useState, useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import ScrollReveal from 'scrollreveal';
import styles from './Services.module.css';
import talk from "../../icons/wired-outline-981-consultation-hover-conversation-alt (2).json"
import house from "../../icons/wired-outline-63-home-hover-3d-roll.json"
import shake from "../../icons/wired-outline-645-people-handshake-transaction-hover-pinch (5).json"
import phone from "../../icons/wired-outline-2806-smartphone-3-hover-phone-ring.json"
import hadmaya from "../../icons/wired-outline-2459-metaverse-hover-roll.json"
import plans from "../../icons/wired-outline-106-map-hover-pinch (1).json"
import shopping from "../../icons/wired-outline-146-trolley-hover-jump.json"
import kitchen from "../../icons/wired-outline-511-kitchen-hover-open.json"
import supervision from "../../icons/wired-outline-981-consultation-hover-conversation-alt (2).json"
import Button from '../button/Button';

const TaliServices = () => {
  const [openServices, setOpenServices] = useState({});
  const playerRefs = useRef({});

  const toggleService = (index) => {
    setOpenServices((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // אייקונים לשירות 01 - 8 שלבים
  const stepIconsService01 = [
    phone,      // 1. שיחת היכרות טלפונית
    talk,       // 2. פגישת היכרות ואפיון צרכים
    house,      // 3. תכנון ראשוני
    hadmaya,    // 4. פיתוח קונספט והדמיות תלת-ממד
    plans,      // 5. הכנת סט תוכניות
    shopping,   // 6. רכישות, תקציב וזמנים
    kitchen,    // 7. תכנון מטבח מלא ופריסות קרמיקה
    supervision // 8. ליווי ופיקוח עד הכניסה לבית
  ];

  // אייקונים לשירות 02 - 4 שלבים
  const stepIconsService02 = [
    phone,      // 1. שיחת ייעוץ והכרות
    house,      // 2. ניתוח החלל
    hadmaya,    // 3. בניית קונספט עיצובי
    shopping    // 4. רשימת רכישות מפורטת
  ];

  // אייקונים לשירות 03 - 4 שלבים
  const stepIconsService03 = [
    phone,      // 1. שיחת הכרות ראשונית
    house,      // 2. שליחת תמונות ומידות
    hadmaya,    // 3. בניית קונספט עיצובי
    plans       // 4. הנחיות מפורטות
  ];

  // אייקונים לשירות 04 - 4 שלבים
  const stepIconsService04 = [
    house,      // 1. ניתוח ראשוני
    plans,      // 2. תכנון מותאם אישית
    hadmaya,    // 3. שדרוג העיצוב
    shake       // 4. מוכנות להצגת הנכס
  ];

  // אייקונים לשירות 05 - 5 שלבים
  const stepIconsService05 = [
    talk,       // 1. ניתוח פרוגרמה
    plans,      // 2. בדיקת תוכניות הקבלן
    house,      // 3. הפקת תיק דייר מלא
    shopping,   // 4. ליווי בבחירת חומרים
    supervision // 5. פיקוח עליון
  ];

  const handleComplete = (ref) => {
    setTimeout(() => {
      ref?.current?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    Object.values(playerRefs.current).forEach((ref) => {
      ref?.playFromBeginning();
    });
  }, [openServices]);

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.stepIconWrapper}`, {
      duration: 1000,
      distance: "100px",
      origin: "right",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
  }, []);

  const createWhatsAppLink = (serviceName) => {
    const phoneNumber = '972544493213';
    const message = `היי טלי, הגעתי מהדף שלך, אשמח לשמוע עוד על ${serviceName}`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  const services = [
    {
      number: "01",
      title: "מסלול ליווי מלא",
      subtitle: "Transform your space, Transform your Life",
      forWho: [
        "לאלו מכם המתכננים בנייה או שיפוץ והלבשת הבית ורוצים תכנון מדויק וחכם.",
        "למי שרכש דירה מקבלן ורוצה להתאים אותה לצרכיו האישיים, מבחינת תכנון, פונקציונליות וסגנון."
      ],
      steps: [
        {
          title: "שיחת היכרות טלפונית ראשונית",
          points: [
            "נדבר על גודל הנכס, מס' החדרים בנכס והחללים אותם תרצו לעצב.",
            "תספרו לי על הצרכים שלכם, הסגנון שאתם אוהבים והאוירה שתרצו ליצור.",
            "אבקש מכם תמונות השראה שיעזרו לי להבין את החזון העיצובי שלכם.",
            "תשלחו לי את תוכנית הדירה/בית עם מידות."
          ],
          note: "מטרת השלב הזה היא להבין בדיוק מה אתם מחפשים ולוודא שהתהליך מתאים עבורכם. במידה והשיחה השרתה בכם ביטחון והרגשה שמצאתם את האדם הנכון לתכנן לכם את הבית המושלם ולהוביל את התהליך – נתקדם לפגישת תכנון מעמיקה."
        },
        {
          title: "פגישת היכרות ואפיון צרכים",
          description: "בשלב הראשון אנחנו יושבים יחד ומבינים לעומק מה חשוב לכם, מה הטעם שלכם, מה הצרכים שלכם ואיך אתם מדמיינים את הבית המושלם. נבין את סדרי העדיפויות שלכם, מה חשוב לכם יותר ומה פחות, נקבע מסגרת תקציב ריאלית ונתכנן איך למקסם אותה.",
          note: "זה המקום לשתף חלומות, השראות, רעיונות והעדפות – כדי שהעיצוב יתאים בדיוק לאורח החיים ולסגנון שלכם."
        },
        {
          title: "תכנון ראשוני",
          description: "לאחר ביצוע מדידות מקצועיות בבית, נערוך פגישה שבה אציג מספר אפשרויות תכנון שונות לבית. כל אופציה תכלול חלוקה מחודשת של הבית, מערך ריהוט מלא, מיקום המטבח וחדרי הרחצה, וכן פירוט אזורי האחסון. מתוך כלל האפשרויות נבחר יחד את התכנון המתאים ביותר עבורכם, אותו נלטש ונפתח לכדי תוכניות עבודה סופיות ומדויקות."
        },
        {
          title: "פיתוח קונספט והדמיות תלת-ממד",
          paragraphs: [
            "אחרי שהתגבשנו על התכנון פנים הנכון עבורכם, אני יוצרת הדמיות תלת-ממד ריאליסטיות שממחישות איך הבית ייראה. שלב תכנון התלת ממד הוא השלב הארוך והחשוב בתהליך, בעזרת ההדמיות תוכלו לראות את התוצאה הסופית עוד לפני שמתחילים בעבודות, לבצע שינויים ולהגיע לתוצאה המדויקת.",
            "העבודה בשלב זה היא על כל חלל בנפרד. ההדמיה מאפשרת לנו לראות את העיצוב מכל הזוויות, להגדיל, להקטין לסובב אלמנטים ולדייק צבעים. בשלב הזה אני יכולה לזהות אם יש מגבלות בשטח. במידה וכן, אעלה בפניכם מספר אופציות לפתרונות אפשריים תוך התייחסות ליתרונות והחסרונות בכל פתרון אפשרי. כמובן שלבסוף אתם אלה שמחליטים מה הכי נכון עבורכם - ועל מה אפשר לוותר."
          ],
          note: "המטרה היא לא רק ליצור חלל מעוצב, אלא גם חלל פרקטי, נוח ומדויק שמתאים בדיוק לאורח החיים שלכם."
        },
        {
          title: "הכנת סט תוכניות בהתאם לצורכי הפרויקט ומכרזים",
          description: "כאן מתחילה העבודה המעשית - אני מכינה סט תוכניות עבודה מפורט לביצוע העבודה לקבלנים ולבעלי המקצוע לפי הנדרש: תוכניות הריסה, בנייה, חשמל, אינסטלציה, נגרות, תאורה, ריצוף, חיפויים וכו'. כאן באה לידי ביטוי המקצועיות שלי והירידה לפרטים הקטנים בכדי שהביצוע יהיה מדויק וברור. בסיומו של שלב זה- אני מוציאה מפרט כמויות קבלני הממפה את העבודה הנדרשת לפי נושאים ומאפשר מכרז נכון ומדויק בין בעלי המקצוע השונים."
        },
        {
          title: "רכישות, תקציב וזמנים",
          description: "בזמן שאני מכינה את תוכניות העבודה, נצא יחד לסבבי רכישות ממוקדים כדי לבחור את כל חומרי הגמר לבית: פרקט, ריצוף, חיפויים, כלים סניטריים, דלתות, תאורה ועוד. מאחר שהאפשרויות רבות ומבלבלות, אכין מראש רשימות מדויקות של הכמויות והספקים המתאימים לסגנון והתקציב שבחרנו - כך שיום הרכישות יהיה יעיל, וחסכוני בזמן ובעלות."
        },
        {
          title: "תכנון מטבח מלא ופריסות קרמיקה",
          description: "כחלק מבחירת חומרי הגמר, אתכנן את המטבח על כל פרטיו; תכנית נגרות מפורטת הכוללת את חלוקת הארונות והמגירות, חומרי גמר וצבע, בהתאמה עם תשתיות נוספות כגון: חשמל, אינסטלציה, משטח שיש ותאורה. אותו תכנון מדוקדק- יבוא לידי ביטוי בפריסות קרמיקה במקלחות. לאחר בחירת הקרמיקה והריצופים- אכין תוכניות עבודה מפורטות לחדרי הרחצה וכן, תוכניות נגרות לארונות אמבטיה ושטחי אחסון נוספים לפי צורך."
        },
        {
          title: "ליווי ופיקוח עד הכניסה לבית",
          paragraphs: [
            "כל מי שהתנסה לפחות פעם אחת בבניה מהיסוד, או אפילו רק בשיפוץ, יודע שמדובר בתהליכים שלרוב לוקחים זמן רב ודורשים משאבים. זוהי מלאכה מורכבת בה לוקחים חלק עשרות בעלי מקצוע, כל אחד מהם מומחה בתחומו.",
            "לכן, חשוב להקפיד ולבחור באיש מקצוע אחד שיוכל ל\"נצח\" על כל אלו. גורם מקצועי שיוכל לבדוק שלא מתקיימת חריגה בלוחות הזמנים, שהתקציב שנקבע מראש נשמר. מקצוען/ית שיוודא שכל אחד מהספקים מבצע את מלאכתו על הצד הטוב ביותר."
          ],
          highlight: "זה הרגע שבו אתם יכולים להמשיך לשתות את הקפה שלכם ללא הפרעות :-)",
          additionalParagraphs: [
            "ואני, אני מוודאת שהכל מתנהל כמו שצריך - לכל אורך עבודות הבנייה, השיפוץ והעיצוב מחדש אני מבצעת פיקוח מלא מול הקבלן ובעלי המקצוע. אני מודעת לכל מה שקורה בשטח בכל רגע ורגע, מטפלת בזמן אמת בכל בעיה שמתעוררת, שאלה שעולה או התלבטות בביצוע. מוודאת שכל פרט מיושם כמו בתוכנית שהפקתי עבורכם בתחילת הדרך, כל רהיט מגיע בזמן וכל העבודה מתבצעת ברמה הגבוהה ביותר."
          ],
          note: "מידת המעורבות שלכם בפרויקט תלויה בכם, ישנם לקוחות שמבקרים בשטח בכל יום וישנם כאלו שמעדיפים לקבל ממני דיווח טלפוני וסיכום עבודות שבועי במייל.",
          conclusion: "במסלול ליווי מלא אלווה אתכם החל משלב התכנון על הנייר ועד לרגע שבו הבית מוכן ואתם יכולים סוף סוף להרגיש שזה הבית שתמיד חלמתם עליו."
        }
      ],
      ctaText: "מוכנים להפוך את הבית שלכם למדויק, מעוצב ומעורר השראה? השאירו פרטים בטופס ונצא לדרך יחד"
    },
    {
      number: "02",
      title: "פגישת ייעוץ ממוקדת להום סטיילינג",
      subtitle: "המגע האחרון שהופך בית לחלום",
      intro: "הום סטיילינג היא דרך מצוינת לשינוי דרמטי במראה הבית, הוספת אנרגיה חדשה וריענון בזמן קצר, במחיר נוח ומבלי לשנות תשתיות או לשבור קירות.",
      forWho: [
        "למי שרוצה לחדש את מראה הבית או חדר מסוים, מבלי להיכנס לתהליכי שיפוץ מסובכים.",
        "למשפחות, זוגות או יחידים שרוצים להפוך חלל ליותר פרקטי, מסודר ומלא סטייל.",
        "לכל מי שזקוק לעין מקצועית שתסייע בבחירת צבעים, טקסטיל, תאורה, ריהוט ואביזרים.",
        "למי שכבר עיצב וריהט את הבית, אבל מרגיש שחסר הטאץ' הסופי שיחבר הכל יחד."
      ],
      whatIncluded: [
        {
          title: "שיחת ייעוץ והכרות",
          text: "נתחיל בשיחה שבה אבין לעומק את העדפות שלכם, הסגנון, הצרכים והתקציב העומד לרשותכם."
        },
        {
          title: "ניתוח החלל",
          text: "במהלך הפגישה נבצע סקירה של החלל שלכם באמצעות ביקור פיזי. במהלכו אזהה את הדרכים להבליט את הפוטנציאל שלו, את המאפיינים האדריכליים שלו, התאורה ותנאי השטח. כל אלו יסייעו לנו לקבל תמונה מלאה של אפשרויות העיצוב העומדות לרשותנו, תוך התחשבות במגבלות הקיימות בשטח. בין אם אתם מתחברים לעיצוב כפרי, מודרני או קלאסי, בין אם מדובר בדירה או בבית, אני מביאה איתי את הידע המעשי והכלים המקצועיים לסייע לכם לבחור קונספט עיצובי כך שיתאים בדיוק לטעמכם. יחד נבחר פלטת צבעים, חומרי גלם, טקסטורות וסוגי ריהוט שישלימו את סגנון העיצוב. אייעץ בנושא פתרונות אחסון, שילובי צבעים וחומרים, מיקום נכון של רהיטים, תאורה מתאימה, טקסטיל, תמונות והוספת פרטי נוי ודקורציה להשלמת האווירה."
        },
        {
          title: "בניית קונספט עיצובי",
          text: "ניצור יחד קונספט שמחבר בין היופי לפרקטיקה, עם דגש על התאמת פריטים ייחודיים וטאצ' אישי."
        },
        {
          title: "רשימת רכישות מפורטת",
          text: "בפגישה נכין יחד רשימה של פריטים שתרצו לקנות בהתאם לסדרי העדיפויות והתקציב שלכם. בסיום הפגישה תקבלו ממני סיכום פגישה מפורט עם תוכנית העמדה של הריהוט הקיים והעתידי בכל חלל, רשימת חנויות וספקים רלוונטיים לרכישת הפריטים לפי הסגנון שנבחר ובהתאם לתקציב שסוכם בפגישה, מס' הצבעים לצביעת הקירות והנחיות לביצוע."
        }
      ],
      details: [
        { label: "כמה זמן אורכת הפגישה?", value: "עד 3 שעות" },
        { label: "עלות", value: "1,500 ₪" },
        { label: "איפה?", value: "באזור המרכז (ראשל\"צ עד חדרה) - מעבר לאזור זה ישנה עלות נוספת" }
      ],
      whyChoose: [
        "חיסכון בזמן וכסף: הום סטיילינג מאפשר לשדרג את הבית במהירות ובתקציב מוגדר.",
        "תוצאה מדויקת: אני מתאימה את העיצוב לסגנון ולצרכים האישיים שלכם.",
        "חוויה מהנה: יחד נהפוך את החלל שלכם למקום שתמיד תרצו לחזור אליו."
      ],
      additionalNote: "ניתן להרחיב את פגישת ייעוץ הלבשת הבית לפגישת ליווי לחנויות למטרת רכישת ריהוט ואקססוריז (בעלות נוספת). כמובן שאני זמינה להתייעצות גם אחרי ומצפה לתמונות לאחר המייקאובר.",
      ctaText: "תנו לי לעזור לכם להכניס סטייל, חום והרמוניה לחלל שלכם ולהפוך אותו למקום שמרגיש כמו בית"
    },
    {
      number: "03",
      title: "עיצוב פנים אונליין",
      subtitle: "מבלי לצאת מהבית",
      intro: "חולמים לשדרג את מראה הבית שלכם אבל לא מוצאים את הזמן לפגישות? עם שירות עיצוב הפנים אונליין שלי, תוכלו לקבל תהליך מותאם אישית, מקצועי ונגיש מבלי לצאת מהבית.",
      forWho: [
        "לכל מי שרוצה לעצב מחדש את ביתו או חדר מסוים ומחפש פתרון פשוט, גמיש ויעיל.",
        "ללקוחות שנמצאים במרחק גיאוגרפי, בארץ או בחו\"ל, ומעוניינים בשירותי עיצוב מקצועיים.",
        "למי שזקוק להכוונה מקצועית בנוגע לבחירת סגנון, צבעים, ריהוט ואביזרים, אבל אוהב לנהל את הביצוע בעצמו.",
        "למשפחות, הורים עסוקים, קרייריסטים או כל מי שרוצה לחסוך זמן יקר ועדיין להנות מבית מעוצב ומרשים."
      ],
      howItWorks: [
        {
          title: "שיחת הכרות ראשונית",
          text: "מתחילים בשיחה שבה אני מבינה את הצרכים, הרצונות והתקציב שלכם."
        },
        {
          title: "שליחת תמונות ומידות",
          text: "אתם מצלמים את החלל הרצוי ושולחים לי את כל הפרטים הנדרשים."
        },
        {
          title: "בניית קונספט עיצובי",
          text: "אני מכינה תוכנית מותאמת אישית הכוללת לוח השראה, צבעים, פרטי ריהוט ואביזרי נוי ודקורציה."
        },
        {
          title: "הנחיות מפורטות",
          text: "תקבלו רשימת קניות מסודרת, חנויות מומלצות והוראות ליישום העיצוב בפועל."
        }
      ],
      whyChoose: [
        "גמישות ונוחות: התהליך מתבצע בזמן שנוח לכם, בלי הגבלה של מיקום.",
        "חיסכון בזמן וכסף: אין צורך בפגישות פיזיות או חיפוש ממושך אחר הפריטים.",
        "תוצאה מושלמת: הבית שלכם יקבל את המראה המעוצב והאישי שתמיד חלמתם עליו."
      ],
      pricing: [
        { item: "חדר שינה", price: "1,200 ₪" },
        { item: "סלון", price: "1,800 ₪" }
      ],
      ctaText: "חסכו זמן, כסף ומאמץ – ותנו לי לעזור לכם להפוך את הבית שלכם לחלום מעוצב ונעים"
    },
    {
      number: "04",
      title: "הום סטייג'ינג",
      subtitle: "הדרך למכור או להשכיר את הנכס שלכם במהירות ובמחיר הטוב ביותר",
      intro: "הום סטייג'ינג הוא שירות מקצועי שמטרתו להציג את הנכס שלכם בצורה האטרקטיבית ביותר עבור קונים או שוכרים פוטנציאליים. בעזרת התאמות עיצוביות נכונות, ניתן להבליט את הפוטנציאל של הנכס, ליצור תחושת חיבור אצל המבקרים, ולהגדיל את הסיכוי לסגור עסקה במהירות ובתנאים מיטביים.",
      forWho: [
        "למי שמוכר דירה או בית ורוצה ליצור רושם ראשוני חיובי וחזק על הקונים.",
        "למשכירים שמחפשים להעלות את ערך הנכס שלהם ולהשכיר אותו מהר יותר.",
        "ליזמי נדל\"ן שמבקשים להציג נכסים במלוא הפוטנציאל שלהם.",
        "למי שרוצה לשדרג את מראה הנכס לצורך צילומים שיווקיים מקצועיים."
      ],
      howItWorks: [
        {
          title: "ניתוח ראשוני",
          text: "אבצע הערכה של נראות הנכס ואזהה את האלמנטים שדורשים שיפור או התאמה."
        },
        {
          title: "תכנון מותאם אישית",
          text: "אתאים תוכנית הום סטייג'ינג ייחודית שתבליט את היתרונות של הנכס."
        },
        {
          title: "שדרוג העיצוב",
          text: "אשדרג את החלל בעזרת עיצוב מחדש, ריהוט זמני, תאורה, צבעים ואביזרים – הכל כדי ליצור אווירה מזמינה ומרשימה."
        },
        {
          title: "מוכנות להצגת הנכס",
          text: "אסייע בהכנת הנכס לצילומים או לביקורי קונים ושוכרים, כדי להבטיח את ההתרשמות הטובה ביותר."
        }
      ],
      whyChoose: [
        "רושם ראשוני מנצח: דירות ובתים שמוצגים באופן נכון מושכים יותר מתעניינים.",
        "מכירה מהירה יותר: נכסים עם הום סטייג'ינג נוטים להימכר מהר יותר ובמחיר גבוה יותר.",
        "שירות מותאם אישית: אני מתאימה את השדרוגים לצרכים, לתקציב ולסגנון שלכם.",
        "השקעה שמחזירה את עצמה: השקעה קטנה בעיצוב הנכס יכולה להוביל לרווחים משמעותיים יותר במכירה או השכרה."
      ],
      pricingNote: "עלות משתנה בהתאם להיקף העבודה",
      ctaText: "תנו לנכס שלכם את היתרון שהוא צריך בשוק התחרותי של היום - זה בהחלט אפשרי!"
    },
    {
      number: "05",
      title: "תכנון ועיצוב דירות קבלן",
      subtitle: "התנהלות מול שינויי דיירים",
      secondSubtitle: "הדרך להפוך דירה סטנדרטית לבית החלומות",
      intro: "רכישת דירה חדשה היא ציון דרך מרגש, אך היא מגיעה כמעט תמיד עם מגבלה אחת משמעותית: המפרט של הקבלן בסיסי, גנרי, ולא באמת מותאם לצרכים של המשפחה המודרנית. נקודות החשמל מוגבלות, המטבח סטנדרטי, ופתרונות האחסון לרוב אינם מספקים.",
      highlight: "כאן מתחיל התפקיד שלי - להפוך את התכנון הראשוני לדירה שמרגישה בדיוק כמו הבית שדמיינתם",
      accompanimentSection: {
        title: "שינויי דיירים בליווי אישי וצמוד עד לאישור התוכנית",
        intro: "תקופת שינויי הדיירים היא קצרה, לחוצה ומלאה בהחלטות שמכתיבות את איכות החיים שלכם לשנים קדימה. כל דחייה או טעות בתכנון עלולות לגרור עלויות מיותרות ועוגמת נפש.",
        highlight: "הליווי שלי מאפשר לכם לעבור את השלב הזה בביטחון מלא וכולל:",
        points: [
          "הפקת סט תוכניות עבודה מלא ומותאם לתקני הקבלן (חשמל, תאורה, אינסטלציה, מיזוג, בינוי).",
          "הגשת תוכניות מדויקות בזמן - כדי לקבל אישור מהיר ולמנוע תיקונים יקרים לאחר קבלת המפתח.",
          "תיאום צמוד מול מתאמת שינויי הדיירים והקפדה על כל פרט קטן."
        ]
      },
      planningSection: {
        title: "לתכנן את הדירה לצרכים שלכם - ולא לסטנדרט של הקבלן",
        intro: "דירה חדשה על הנייר יכולה להיראות נפלא, אבל לא תמיד היא תומכת באמת בצורת החיים שלכם - אהבה לארח, צורך באחסון רב, עבודה מהבית, משפחה.",
        checkTitle: "בשלב התכנון נבדוק יחד:",
        checkPoints: [
          "את העמדת הריהוט הנכונה לכל חלל",
          "את התאמת המטבח לשימוש היום-יומי שלכם",
          "את אפשרויות להטמעת אחסון חכם",
          "את מקסום חלוקת החלל במסגרת האפשרויות שהקבלן מאפשר"
        ],
        goal: "לקחת דירה סטנדרטית ולהפוך אותה לבית עם אופי, פונקציונליות והרמוניה."
      },
      processSteps: [
        {
          title: "ניתוח פרוגרמה",
          text: "הכרות מעמיקה עם הצרכים, השגרה, ההעדפות והתקציב שלכם."
        },
        {
          title: "בדיקת תוכניות הקבלן",
          text: "איתור כשלים, הצפת אילוצים והצעת פתרונות חכמים לשדרוג התכנון."
        },
        {
          title: "הפקת תיק דייר מלא",
          text: "תוכניות חשמל, מיזוג, ריצוף, בינוי ועוד - מוכנות להגשה למתאמת שמטעם הפרויקט."
        },
        {
          title: "ליווי בבחירת חומרים",
          text: "ייעוץ בבחירת ריצוף, חיפויים, כלים סניטריים, גופי תאורה ודלתות מול ספקי הקבלן, תוך התאמה לסגנון, לתקציב ולמפרט."
        },
        {
          title: "פיקוח עליון",
          text: "מעקב לווידוא שהביצוע בשטח אכן תואם את התוכניות שסוכמו ואושרו."
        }
      ],
      ctaText: "לעוד פרטים לחצו כאן"
    }
  ];

  const getStepIcons = (serviceNumber) => {
    switch (serviceNumber) {
      case "01":
        return stepIconsService01;
      case "02":
        return stepIconsService02;
      case "03":
        return stepIconsService03;
      case "04":
        return stepIconsService04;
      case "05":
        return stepIconsService05;
      default:
        return stepIconsService01;
    }
  };

  const renderServiceContent = (service, serviceIndex) => {
    // שירות 01 - מסלול ליווי מלא
    if (service.number === "01" && service.steps) {
      const icons = getStepIcons(service.number);
      return (
        <>
          <div className={styles.forWhoSection}>
            <h3 className={styles.sectionHeading}>למי זה מתאים?</h3>
            <ul className={styles.bulletList}>
              {service.forWho.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={styles.interactiveTimeline}>
            <h3 className={styles.sectionHeading}>איך זה עובד?</h3>
            <div className={styles.timelineContainer}>
              {service.steps.map((step, i) => {
                const refKey = `service-${serviceIndex}-step-${i}`;
                return (
                  <div key={i} className={styles.timelineStep}>
                    <div className={styles.timelineStepHeader}>
                      <div className={styles.timelineStepNumber}>
                        <div className={styles.stepIconWrapper}>
                          <Player
                            icon={icons[i]}
                            ref={(ref) => (playerRefs.current[refKey] = ref)}
                            size="100%"
                            onComplete={() => handleComplete(playerRefs.current[refKey])}
                          />
                        </div>
                        {i < service.steps.length - 1 && (
                          <div className={styles.stepConnector}></div>
                        )}
                      </div>
                      <div className={styles.timelineStepContent}>
                        <div className={styles.stepTitleRow}>
                          <h4 className={styles.stepTitle}>{step.title}</h4>
                          {step.duration && (
                            <span className={styles.stepDuration}>{step.duration}</span>
                          )}
                        </div>
                        {step.description && <p className={styles.text}>{step.description}</p>}
                        {step.points && (
                          <ul className={styles.checkList}>
                            {step.points.map((point, j) => (
                              <li key={j}>{point}</li>
                            ))}
                          </ul>
                        )}
                        {step.paragraphs && step.paragraphs.map((p, j) => (
                          <p key={j} className={styles.text}>{p}</p>
                        ))}
                        {step.highlight && <p className={styles.highlight}>{step.highlight}</p>}
                        {step.additionalParagraphs && step.additionalParagraphs.map((p, j) => (
                          <p key={`add-${j}`} className={styles.text}>{p}</p>
                        ))}
                        {step.note && <p className={styles.note}>{step.note}</p>}
                        {step.conclusion && <p className={styles.text}>{step.conclusion}</p>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {service.ctaText && (
            <p className={styles.highlight}>{service.ctaText}</p>
          )}

          <div className={styles.ctaButtonWrapper}>
            <a
              href={createWhatsAppLink(service.title)}
              className={styles.ctaButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaButtonIcon}>💬</span>
              לשיחת ייעוץ ראשונית
            </a>
          </div>
        </>
      );
    }

    // שירות 02 - הום סטיילינג
    if (service.number === "02") {
      const icons = getStepIcons(service.number);
      return (
        <>
          {service.intro && <p className={styles.intro}>{service.intro}</p>}
          
          <div className={styles.forWhoSection}>
            <h3 className={styles.sectionHeading}>למי זה מתאים?</h3>
            <ul className={styles.bulletList}>
              {service.forWho.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {service.whatIncluded && (
            <div className={styles.interactiveTimeline}>
              <h3 className={styles.sectionHeading}>מה כולל השירות?</h3>
              <div className={styles.timelineContainer}>
                {service.whatIncluded.map((item, i) => {
                  const refKey = `service-${serviceIndex}-step-${i}`;
                  return (
                    <div key={i} className={styles.timelineStep}>
                      <div className={styles.timelineStepHeader}>
                        <div className={styles.timelineStepNumber}>
                          <div className={styles.stepIconWrapper}>
                            <Player
                              icon={icons[i]}
                              ref={(ref) => (playerRefs.current[refKey] = ref)}
                              size="100%"
                              onComplete={() => handleComplete(playerRefs.current[refKey])}
                            />
                          </div>
                          {i < service.whatIncluded.length - 1 && (
                            <div className={styles.stepConnector}></div>
                          )}
                        </div>
                        <div className={styles.timelineStepContent}>
                          <div className={styles.stepTitleRow}>
                            <h4 className={styles.stepTitle}>{item.title}</h4>
                          </div>
                          <p className={styles.text}>{item.text}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {service.details && (
            <div className={styles.detailsSection}>
              {service.details.map((detail, i) => (
                <div key={i} className={styles.detailItem}>
                  <span className={styles.detailLabel}>{detail.label}</span>
                  <span className={styles.detailValue}>{detail.value}</span>
                </div>
              ))}
            </div>
          )}

          {service.whyChoose && (
            <div className={styles.whyChooseSection}>
              <h3 className={styles.sectionHeading}>למה לבחור בשירות הום סטיילינג?</h3>
              <ul className={styles.bulletList}>
                {service.whyChoose.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {service.additionalNote && (
            <p className={styles.note}>{service.additionalNote}</p>
          )}

          {service.ctaText && (
            <p className={styles.highlight}>{service.ctaText}</p>
          )}

          <div className={styles.ctaButtonWrapper}>
            <a
              href={createWhatsAppLink(service.title)}
              className={styles.ctaButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaButtonIcon}>💬</span>
              לקביעת שיחת ייעוץ ראשונית חינם
            </a>
          </div>
        </>
      );
    }

    // שירות 03 - עיצוב פנים אונליין
    if (service.number === "03") {
      const icons = getStepIcons(service.number);
      return (
        <>
          {service.intro && <p className={styles.intro}>{service.intro}</p>}
          
          <div className={styles.forWhoSection}>
            <h3 className={styles.sectionHeading}>למי השירות מתאים?</h3>
            <ul className={styles.bulletList}>
              {service.forWho.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {service.howItWorks && (
            <div className={styles.interactiveTimeline}>
              <h3 className={styles.sectionHeading}>איך זה עובד?</h3>
              <div className={styles.timelineContainer}>
                {service.howItWorks.map((item, i) => {
                  const refKey = `service-${serviceIndex}-step-${i}`;
                  return (
                    <div key={i} className={styles.timelineStep}>
                      <div className={styles.timelineStepHeader}>
                        <div className={styles.timelineStepNumber}>
                          <div className={styles.stepIconWrapper}>
                            <Player
                              icon={icons[i]}
                              ref={(ref) => (playerRefs.current[refKey] = ref)}
                              size="100%"
                              onComplete={() => handleComplete(playerRefs.current[refKey])}
                            />
                          </div>
                          {i < service.howItWorks.length - 1 && (
                            <div className={styles.stepConnector}></div>
                          )}
                        </div>
                        <div className={styles.timelineStepContent}>
                          <div className={styles.stepTitleRow}>
                            <h4 className={styles.stepTitle}>{item.title}</h4>
                          </div>
                          <p className={styles.text}>{item.text}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {service.whyChoose && (
            <div className={styles.whyChooseSection}>
              <h3 className={styles.sectionHeading}>למה לבחור בעיצוב פנים אונליין?</h3>
              <ul className={styles.bulletList}>
                {service.whyChoose.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {service.pricing && (
            <div className={styles.pricingSection}>
              <h3 className={styles.sectionHeading}>עלות</h3>
              <div className={styles.pricingGrid}>
                {service.pricing.map((item, i) => (
                  <div key={i} className={styles.pricingItem}>
                    <span className={styles.pricingLabel}>{item.item}</span>
                    <span className={styles.pricingValue}>{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {service.ctaText && (
            <p className={styles.highlight}>{service.ctaText}</p>
          )}

          <div className={styles.ctaButtonWrapper}>
            <a
              href={createWhatsAppLink(service.title)}
              className={styles.ctaButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaButtonIcon}>💬</span>
              לקביעת שיחת ייעוץ ראשונית
            </a>
          </div>
        </>
      );
    }

    // שירות 04 - הום סטייג'ינג
    if (service.number === "04") {
      const icons = getStepIcons(service.number);
      return (
        <>
          {service.intro && <p className={styles.intro}>{service.intro}</p>}
          
          <div className={styles.forWhoSection}>
            <h3 className={styles.sectionHeading}>למי זה מתאים?</h3>
            <ul className={styles.bulletList}>
              {service.forWho.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {service.howItWorks && (
            <div className={styles.interactiveTimeline}>
              <h3 className={styles.sectionHeading}>איך זה עובד?</h3>
              <div className={styles.timelineContainer}>
                {service.howItWorks.map((item, i) => {
                  const refKey = `service-${serviceIndex}-step-${i}`;
                  return (
                    <div key={i} className={styles.timelineStep}>
                      <div className={styles.timelineStepHeader}>
                        <div className={styles.timelineStepNumber}>
                          <div className={styles.stepIconWrapper}>
                            <Player
                              icon={icons[i]}
                              ref={(ref) => (playerRefs.current[refKey] = ref)}
                              size="100%"
                              onComplete={() => handleComplete(playerRefs.current[refKey])}
                            />
                          </div>
                          {i < service.howItWorks.length - 1 && (
                            <div className={styles.stepConnector}></div>
                          )}
                        </div>
                        <div className={styles.timelineStepContent}>
                          <div className={styles.stepTitleRow}>
                            <h4 className={styles.stepTitle}>{item.title}</h4>
                          </div>
                          <p className={styles.text}>{item.text}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {service.whyChoose && (
            <div className={styles.whyChooseSection}>
              <h3 className={styles.sectionHeading}>למה לבחור בהום סטייג'ינג?</h3>
              <ul className={styles.bulletList}>
                {service.whyChoose.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {service.pricingNote && (
            <div className={styles.pricingNote}>
              <span className={styles.pricingNoteLabel}>עלות:</span>
              <span className={styles.pricingNoteValue}>{service.pricingNote}</span>
            </div>
          )}

          {service.ctaText && (
            <p className={styles.highlight}>{service.ctaText}</p>
          )}

          <div className={styles.ctaButtonWrapper}>
            <a
              href={createWhatsAppLink(service.title)}
              className={styles.ctaButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaButtonIcon}>💬</span>
              לקביעת שיחת ייעוץ ראשונית חינם
            </a>
          </div>
        </>
      );
    }

    // שירות 05 - דירות קבלן (מורחב)
    if (service.number === "05") {
      const icons = getStepIcons(service.number);
      return (
        <>
          {service.secondSubtitle && (
            <h3 className={styles.secondSubtitle}>{service.secondSubtitle}</h3>
          )}
          
          {service.intro && <p className={styles.intro}>{service.intro}</p>}
          
          {service.highlight && (
            <p className={styles.highlight}>{service.highlight}</p>
          )}

          {/* סקשן שינויי דיירים */}
          {service.accompanimentSection && (
            <div className={styles.accompanimentSection}>
              <h3 className={styles.sectionHeading}>{service.accompanimentSection.title}</h3>
              <p className={styles.text}>{service.accompanimentSection.intro}</p>
              <p className={styles.highlightSmall}>{service.accompanimentSection.highlight}</p>
              <ul className={styles.checkList}>
                {service.accompanimentSection.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          )}

          {/* סקשן תכנון לצרכים */}
          {service.planningSection && (
            <div className={styles.planningSection}>
              <h3 className={styles.sectionHeading}>{service.planningSection.title}</h3>
              <p className={styles.text}>{service.planningSection.intro}</p>
              <p className={styles.checkTitle}>{service.planningSection.checkTitle}</p>
              <ul className={styles.checkList}>
                {service.planningSection.checkPoints.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
              <p className={styles.goalText}>
                <strong>המטרה:</strong> {service.planningSection.goal}
              </p>
            </div>
          )}

          {/* תהליך הליווי */}
          {service.processSteps && (
            <div className={styles.interactiveTimeline}>
              <h3 className={styles.sectionHeading}>מה כולל תהליך הליווי לדירה מקבלן?</h3>
              <div className={styles.timelineContainer}>
                {service.processSteps.map((step, i) => {
                  const refKey = `service-${serviceIndex}-step-${i}`;
                  return (
                    <div key={i} className={styles.timelineStep}>
                      <div className={styles.timelineStepHeader}>
                        <div className={styles.timelineStepNumber}>
                          <div className={styles.stepIconWrapper}>
                            <Player
                              icon={icons[i]}
                              ref={(ref) => (playerRefs.current[refKey] = ref)}
                              size="100%"
                              onComplete={() => handleComplete(playerRefs.current[refKey])}
                            />
                          </div>
                          {i < service.processSteps.length - 1 && (
                            <div className={styles.stepConnector}></div>
                          )}
                        </div>
                        <div className={styles.timelineStepContent}>
                          <div className={styles.stepTitleRow}>
                            <span className={styles.stepNumber}>{i + 1}.</span>
                            <h4 className={styles.stepTitle}>{step.title}</h4>
                          </div>
                          <p className={styles.text}>{step.text}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className={styles.ctaButtonWrapper}>
            <a
              href={createWhatsAppLink(service.title)}
              className={styles.ctaButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.ctaButtonIcon}>💬</span>
              {service.ctaText}
            </a>
          </div>
        </>
      );
    }

    // Default fallback
    return (
      <>
        {service.intro && <p className={styles.intro}>{service.intro}</p>}
        {service.forWho && (
          <div className={styles.forWhoSection}>
            <h3 className={styles.sectionHeading}>למי השירות מתאים?</h3>
            <ul className={styles.bulletList}>
              {service.forWho.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        <div className={styles.ctaButtonWrapper}>
          <a
            href={createWhatsAppLink(service.title)}
            className={styles.ctaButton}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.ctaButtonIcon}>💬</span>
            לעוד פרטים לחצו כאן
          </a>
        </div>
      </>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.mainTitle}>
            <span className={styles.titleHighlight}>שירותי הסטודיו</span>
          </h1>
          <p className={styles.mainSubtitle}>
            הבית שלנו, המקום שבו אנו מתחילים ומסיימים כל יום, הוא המקום שבו אנחנו נטענים באנרגיה מוצאים שלווה. עם השנים, מתוך עבודה משותפת עם לקוחות מגוונים, למדתי שכל בית, כל אדם וכל משפחה הם ייחודיים ולכל אחד חלומות וצרכים אישיים שונים. מתוך ההבנה הזו, יצרתי מגוון מסלולי ליווי גמישים ומותאמים אישית, המתאימים לכל תקציב, כדי שכל לקוח יוכל למצוא את הפתרון המושלם עבורו.
          </p>
        </div>

        <div className={styles.servicesContainer}>
          {services.map((service, index) => (
            <div
              key={index}
              className={`${styles.serviceItem} ${
                openServices[index] ? styles.serviceItemOpen : ''
              }`}
            >
              <button
                className={styles.serviceHeader}
                onClick={() => toggleService(index)}
              >
                <div className={styles.serviceHeaderContent}>
                  <div className={styles.serviceNumber}>{service.number}</div>
                  <div className={styles.serviceTitleWrapper}>
                    <h2 className={styles.serviceTitle}>{service.title}</h2>
                    {service.subtitle && (
                      <p className={styles.serviceSubtitle}>{service.subtitle}</p>
                    )}
                  </div>
                </div>
                <div
                  className={`${styles.serviceIcon} ${
                    openServices[index] ? styles.serviceIconOpen : ''
                  }`}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>

              <div className={styles.serviceContent}>
                <div className={styles.serviceContentInner}>
                  {renderServiceContent(service, index)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Button text="להתייעצות איתי לגבי המסלולים לחצו כאן" message="היי טלי, הגעתי מהדף שלך, אשמח להתייעץ איתך לגבי המסלול שהכי מתאים לי"/>
    </div>
  );
};

export default TaliServices;